import React, { useRef, useState } from "react";
import { CloseIcon, CopyIcon } from "asset/icons";
import BankTransferTab from "./tabs/BankTransferTab";
import NGNFlagImg from "asset/images/Currency.svg";
import PaymentLinkSuccessModal from "./PaymentLinkSuccessModal";

const FundWalletModal = ({ isOpen, onClose, walletData, providers }) => {
  const [activeTab,] = useState("bank");
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
  const bankTransferRef = useRef(null);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/40 z-[100] flex justify-center items-center px-4">
        <div className="bg-white max-h-[480px] overflow-auto hide-scrollbar w-full max-w-lg rounded-2xl  relative">
                <div className="px-6 pt-6">
                    <button className="absolute right-5 top-5 text-gray-600" onClick={onClose}>
                        <CloseIcon />
                    </button>

                    <h2 className="text-2xl font-bold text-[#111827]">Fund wallet</h2>

                    {/* <div className="flex bg-[#F2F3FC] rounded-xl p-1 w-full max-w-md mx-auto mt-4 mb-6">
                        {tabs.map(({ id, label }) => (
                            <button
                                key={id}
                                onClick={() => setActiveTab(id)}
                                className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all
                ${activeTab === id ? "bg-white text-[#111827] shadow-sm" : "text-[#6B7280]"}`}
                            >
                                {label}
                            </button>
                        ))}
                    </div> */}

                    {activeTab === "bank" && (
                        <BankTransferTab
                            ref={bankTransferRef}
                            walletData={walletData}
                            providers={providers}
                        />
                    )}

                    {activeTab === "card" && (
                        <div className="mt-6">
                            <label className="block text-[#111827] text-base font-medium mb-4">
                                How much do you want to fund?
                            </label>

                            <div className="flex  max-w-md">
                                <div className="flex items-start text-7xl font-normal leading-none">
                                    <span className="text-[#475467] text-2xl pt-3 mr-1">$</span>
                                    <input
                                        type="number"
                                        min={1000}
                                        placeholder="0"
                                        className="!shadow-none outline-none w-full caret-[#6F00FF]"
                                    />
                                </div>
                                <div className="flex !pt-5 gap-1 ml-4">
                                    <img src={NGNFlagImg} alt="NGN" className="w-5 h-5" />
                                    <span className="text-sm text-[#4B5563] font-medium">NGN</span>
                                </div>
                            </div>

                            <p className="text-[#6B7280] text-sm mt-2">Minimum amount is ₦1,000</p>
                        </div>
                    )}

                    {activeTab === "link" && (
                        <div className="mt-6">
                            <label className="block text-[#111827] text-base font-medium mb-4">
                                How much do you want to fund?
                            </label>

                            <div className="flex  max-w-md">
                                <div className="flex items-start text-7xl font-normal leading-none">
                                    <span className="text-[#475467] text-2xl pt-3 mr-1">$</span>
                                    <input
                                        type="number"
                                        min={1000}
                                        placeholder="0"
                                        className="!shadow-none outline-none w-full caret-[#6F00FF]"
                                    />
                                </div>
                                <div className="flex !pt-5 gap-1 ml-4">
                                    <img src={NGNFlagImg} alt="NGN" className="w-5 h-5" />
                                    <span className="text-sm text-[#4B5563] font-medium">NGN</span>
                                </div>
                            </div>

                            <p className="text-[#6B7280] text-sm mt-2">Minimum amount is ₦1,000</p>
                        </div>
                    )}
                </div>

                {/* You can implement "card" and "link" tabs similarly later */}

                {activeTab === "bank" ? (
                    <div className="mt-6 flex justify-between items-center border-t p-4">
                        <button
                            onClick={() => bankTransferRef.current?.copyActive()}
                            className="flex items-center gap-2 text-sm font-semibold text-[#111827]"
                        >
                            <CopyIcon className="w-5 h-5 [&_path]:stroke-[#111827]" />
                            Copy account details
                        </button>
                        <button
                            onClick={onClose}
                            className="bg-[#6F00FF] text-white px-8 py-2.5 rounded-lg text-sm font-medium"
                        >
                            Done
                        </button>
                    </div>
                ) : (
                    <div className="mt-6 flex justify-end border-t p-3 gap-3">
                        <button onClick={onClose} className="text-base text-gray-600">
                            Back
                        </button>
                        <button
                            onClick={() => {
                                if (activeTab === "link") {
                                    setShowPaymentLinkModal(true);
                                } else {
                                    onClose();
                                }
                            }}
                            className="bg-[#6F00FF] text-white px-6 py-2 rounded-lg text-sm"
                        >
                            {activeTab === "card" ? "Continue with card" : "Share payment link"}
                        </button>
                    </div>
                )}
            </div>
            <PaymentLinkSuccessModal
                isOpen={showPaymentLinkModal}
                onClose={() => setShowPaymentLinkModal(false)}
                businessName="Vance refrigeration"
                paymentLink="https://tradevu.co/pay-vance"
            />
        </div>
    );
};

export default FundWalletModal;
